'use client';

import { useCallback } from 'react';
import { usePathname } from 'next/navigation';

/**
 * Returns a function that redirects to Auth0 Universal Login,
 * preserving the current path as the returnTo destination.
 */
export function useLoginRedirect() {
  const pathname = usePathname();

  return useCallback(() => {
    window.location.href = `/auth/login?returnTo=${encodeURIComponent(pathname)}`;
  }, [pathname]);
}
